import { Build, Component, Element, Host, Prop, h } from '@stencil/core';

import { getAssetSrc, isEnterKey } from '../../helpers/helpers';
@Component({
  tag: 'cms-video',
  styleUrl: 'cms-video.scss',
  shadow: true,
})
export class CmsVideo {
  private videoNode: HTMLVideoElement;
  private readonly poster = 'video-poster-webp-750x420.webp';

  /**
   * set the static video poster
   */
  @Prop() videoPoster: string;
  /**
   * set the video Source
   */
  @Prop() videoSrc: string;

  /**
   * set the accessible name
   */
  @Prop() accessibleName: string;

  /**
   * set the accessible name for the play-button
   */
  @Prop() buttonAccessibleName: string;

  @Element() host: HTMLElement;

  componentDidLoad() {
    if (this.videoSrc !== undefined) {
      this.videoNode = this.host.shadowRoot.querySelector('.cms-video');
    }
  }

  private videoHandler() {
    if (!(this.videoNode !== undefined && this.videoNode.readyState === 0)) {
      return;
    }
    this.videoNode.load();
    this.videoNode.play();
    this.videoNode.setAttribute('controls', 'true');
    this.videoNode.focus();
    this.videoNode.volume = 0.1;
    const playIconContainer = this.videoNode
      .previousElementSibling as HTMLDivElement;
    playIconContainer.style.display = 'none';
  }

  private handleVideoInteraction(event?: KeyboardEvent) {
    if (event && !isEnterKey(event)) {
      return;
    }
    this.videoHandler();
  }

  render() {
    const videoStyles = {
      width: '100%',
      height: 'auto',
      cursor: 'pointer',
    };
    return (
      <Host aria-label={this.accessibleName}>
        <button
          class='video-inner'
          type='button'
          aria-label={this.buttonAccessibleName}
          onClick={() => this.handleVideoInteraction()}
        >
          <cms-video-play-button />
          <video
            preload='none'
            style={videoStyles}
            onClick={() => this.handleVideoInteraction()}
            onKeyDown={() => this.handleVideoInteraction()}
            class='cms-video'
            poster={Build.isBrowser ? getAssetSrc(this.poster) : null}
          >
            <source type='video/mp4' src={this.videoSrc} />
            <track kind='captions' src='' label='English' />
          </video>
        </button>
      </Host>
    );
  }
}
